import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Field, FieldLabel } from '@/components/ui/field'

interface IProps {
  label: string
  placeholder?: string
  loading: boolean
  onSubmit: (id: string) => void
}

export default function IdLookup({ label, placeholder, loading, onSubmit }: IProps) {
  const { t } = useTranslation()
  const [value, setValue] = React.useState('')

  return (
    <form
      className="flex items-end gap-2"
      onSubmit={(e) => {
        e.preventDefault()
        if (value.trim()) onSubmit(value.trim())
      }}
    >
      <Field className="flex-1">
        <FieldLabel htmlFor="admin-id-lookup">{label}</FieldLabel>
        <Input id="admin-id-lookup" value={value} placeholder={placeholder} onChange={(e) => setValue(e.target.value)} />
      </Field>
      <Button type="submit" disabled={loading || !value.trim()}>
        {t('admin::Load')}
      </Button>
    </form>
  )
}
